import { application } from "./application"

import AutosaveController from "./autosave_controller"
import BookingTypeController from "./booking_type_controller"
import CalendarController from "./calendar_controller"
import DropdownController from "./dropdown_controller"
import DropzoneController from "./dropzone_controller"
import GalleryController from "./gallery_controller"
import GuideNavController from "./guide_nav_controller"
import HelloController from "./hello_controller"
import HomeSearchController from "./home_search_controller"
import LightboxController from "./lightbox_controller"
import LocationSearchController from "./location_search_controller"
import MapController from "./map_controller"
import NestedFormController from "./nested_form_controller"
import PromptGeneratorController from "./prompt_generator_controller"
import SearchController from "./search_controller"
import SortableController from "./sortable_controller"
import TabsController from "./tabs_controller"
import ToastController from "./toast_controller"
import ToggleController from "./toggle_controller"
import NavigateController from "./navigate_controller"
import TomSelectController from "./tom_select_controller"

application.register("autosave", AutosaveController)
application.register("booking-type", BookingTypeController)
application.register("calendar", CalendarController)
application.register("dropdown", DropdownController)
application.register("dropzone", DropzoneController)
application.register("gallery", GalleryController)
application.register("guide-nav", GuideNavController)
application.register("hello", HelloController)
application.register("home-search", HomeSearchController)
application.register("lightbox", LightboxController)
application.register("location-search", LocationSearchController)
application.register("map", MapController)
application.register("navigate", NavigateController)
application.register("nested-form", NestedFormController)
application.register("prompt-generator", PromptGeneratorController)
application.register("search", SearchController)
application.register("sortable", SortableController)
application.register("tabs", TabsController)
application.register("toast", ToastController)
application.register("toggle", ToggleController)
application.register("tom-select", TomSelectController)
